import React from "react";
import { SiSap, SiSalesforce, SiMulesoft, SiMongodb, SiStripe, SiSnowflake, SiPostman } from "react-icons/si";
import { BrandOracleMark } from "./BrandOracle";

const ITEMS = [
  { Icon: SiSap, label: "SAP" },
  { Icon: BrandOracleMark, label: "Oracle" },
  { Icon: SiSalesforce, label: "Salesforce" },
  { Icon: SiMulesoft, label: "MuleSoft" },
  { Icon: SiSnowflake, label: "Snowflake" },
  { Icon: SiMongodb, label: "MongoDB" },
  { Icon: SiStripe, label: "Stripe" },
  { Icon: SiPostman, label: "Postman" },
];

export const PlatformLogos = () => {
  return (
    <div className="relative overflow-hidden marquee-mask" data-testid="platform-logos">
      <div className="flex gap-16 animate-marquee whitespace-nowrap py-2">
        {[...ITEMS, ...ITEMS].map(({ Icon, label }, i) => (
          <div key={i} className="flex items-center gap-3 text-xp-muted/80 hover:text-xp-text transition-colors">
            <Icon className="h-7 w-7" />
            <span className="font-display text-xl tracking-display">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlatformLogos;
